












import { Component, Prop, Vue } from 'vue-property-decorator';
import { Moment } from '@/Moment'
import { Auction } from '@/Auction'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import { Plotly } from '@rleys/vue-plotly-basic'

@Component({
  name: 'MomentSquareComponent',
  components: { Plotly }
})
export default class MomentSquareComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public moment: Moment

  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
